export default __webpack_public_path__ + "static/media/s13.c0865c2d.jpg";